module.exports = __webpack_public_path__ + "static/media/bi_winner_emblem_white.58ddb1a5.png";